import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from '../pages/Home';
import Website from '../pages/Website';
import Hosting from '../pages/Hosting';
import Helpdesk from '../pages/Helpdesk';
import Contact from '../pages/Contact';

const routes = () => (
  <Switch>
    <Route path="/" exact component={Home} />
    <Route path="/webbproduktion/" exact component={Website} />
    <Route path="/helpdesk/" exact component={Helpdesk} />
    <Route path="/kontakta-oss/" exact component={Contact} />
    <Route path="/hosting/" exact component={Hosting} />
  </Switch>
);

export default routes;



// WEBPACK FOOTER //
// ./Routes/index.js